var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-timepicker", {
    ref: "picker",
    class: _vm.inputclass,
    attrs: {
      format: "HH:mm",
      "minute-interval": _vm.minuteinterval,
      readonly: _vm.readonly,
      "time-value": _vm.value,
      value: _vm.value,
      hideClearButton: true,
    },
    on: {
      "update:timeValue": function ($event) {
        _vm.value = $event
      },
      "update:time-value": function ($event) {
        _vm.value = $event
      },
      change: _vm.onChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }